/* lua.js generated code 0.3.1 */

GameItemType = table(
    [1, "kNone", 0],
    [1, "kAnimal", 1],
    [1, "kGift", 6],
    [1, "kBlackCuteBall", 17],
    [1, "kSuperBlocker", 23],
    [1, "kIce", 37],
    [1, "kSnow", 40],
    [1, "kLock", 45],
    [1, "kCoin", 46],
    [1, "kCrystal", 47],
    [1, "kAlienA", 48],
    [1, "kAlienB", 49],
    [1, "kRope", 56],
    [1, "kChain", 57],
    [1, "kSeaAnimal_1_1", 63],
    [1, "kSeaAnimal_1_2", 64],
    [1, "kSeaAnimal_2_1", 65],
    [1, "kSeaAnimal_2_2", 66],
    [1, "kSeaAnimal_2_3", 67],
    [1, "kSeaAnimal_3_2", 68],
    [1, "kColorBlock_1", 69],
    [1, "kColorBlock_2", 70],
    [1, "kColorBlock_3", 71],
    [1, "kColorBlock_4", 72],
    [1, "kColorBlock_5", 73],
    [1, "kColorBlock_6", 74],
    [1, "kFish", 75],
    [1, "kCircle", 83],
    [1, "kRoost", 84],
    [1, "kHoneyBottle", 96],
    [1, "kHoney", 97],
    [1, "kStone", 98],
    [1, "kMissile", 99],
    [1, "kVar_Snow", 101],
    [1, "kFurball", 109],
    [1, "kDandelion", 119],
    [1, "kDandelionSeed", 120],
    [1, "kSubmarine", 121],
    [1, "kGather", 122],
    [1, "kReef", 123],
    [1, "kBoat", 126],
    [1, "kDigWater", 127],
    [1, "kSoil", 128],
    [1, "kGum", 131],
    [1, "kVariousBox", 138],
    [1, "kFishClock", 142],
    [1, "kStarfish", 143],
    [1, "kVenom", 146],
    [1, "kFlowerVine", 148],
    [1, "kJellyfish", 152],
    [1, "kLighthouse", 153],
    [1, "kSurfingCat", 159],
    [1, "kPaw", 166],
    [1, "kPursueStart", 173],
    [1, "kPursueEnd", 174],
    [1, "kColorCollector", 176],
    [1, "kSurpriseBox", 184],
    [1, "kSurpriseBonus", 186],
    [1, "kBigBox", 189],
    [1, "kCake", 193],
    [1, "kBlockMachine", 202],
    [1, "kBowknot", 203],
    [1, "kScoreAnimal", 208],
    [1, "kShell", 215],
    [1, "kSoda_1_2", 218],
    [1, "kSoda_2_1", 219],
    [1, "kSoda_1_2_symmetry", 232],
    [1, "kSoda_2_1_symmetry", 233],
    [1, "kSuperHoneyBottle", 226],
    [1, "kWaterBomb", 234],
    [1, "kRiceBag", 241],
    [1, "kGold", 242],
    [1, "kSilver", 243],
    [1, "kRatel", 248],
    [1, "kCapsuleToy", 265],
    [1, "kIceBomb", 270],
    [1, "kCakeShooter", 277],
    [1, "kGummyWorm", 284],
    [1, "kBlastCrystal", 291],
    [1, "kRocket", 292],
    [1, "kPropBlock", 299],
    [1, "kJamJar", 329],
    [1, "kFishnet", 350],
    [1, "kFlashBird", 352],
    [1, "kCheeseRat", 359],
    [1, "kPastry", 365],
    [1, "kPopCan", 372],
    [1, "kFireWork", 378],
    [1, "kFireCracker", 385],
    [1, "kIcecream", 389],
    [1, "kLamp", 390],
    [1, "kQualifyHat", 396],
    [1, "kEgg", 397],
    [1, "kDye", 400],
    [1, "kMagicbottle", 406],
    [1, "kBombCandy", 409],
    [1, "kPopcorn", 428],
    [1, "kDiamondSolid", 432],
    [1, "kDiamond", 435],
    [1, "kShark", 461],
    [1, "kMiniOctopus", 468],
    [1, "kJamBox", 472],
    [1, "kJam", 478],
    [1, "kFoamBomb", 480],
    [1, "kIcePopBox", 485],
    [1, "kCircusA", 488],
    [1, "kCircusB", 489],
    [1, "kCircusBall", 490],
    [1, "kWoodBox", 492],
    [1, "kMangosteen", 499],
    [1, "kMax", 600]
)
LockItemType = table.const(table(
    [1, "kGoldPackage", 244],
    [1, "kCandyFloss", 247],
    [1, "kWaterBox", 252],
    [1, "kVulnerable", 253],
    [1, "kGummyWorm", 284],
    [1, "kColoredFrosting", 300],
    [1, "kCandyYoyo", 328],
    [1, "kMint", 347],
    [1, "kSeaAnemone", 348],
    [1, "kMushroom", 349],
    [1, "kUFO", 351],
    [1, "kCroissant", 369],
    [1, "kFilbert", 375],
    [1, "kIcecreamCollector", 388],
    [1, "kIcecream", 389],
    [1, "kLaser", 391],
    [1, "kTorpedo", 417],
    [1, "kBiscuit", 424],
    [1, "kNest", 429],
    [1, "kHunter", 431],
    [1, "kTurnTileControlA", 439],
    [1, "kTurnTileControlB", 449],
    [1, "kCannedFish", 458],
    [1, "kSafe", 486],
    [1, "kSupportStick", 504]
))
CoverItemType = table.const(table([1, "kNestDoll", 285]))
CeilItemType = table.const(table(
    [1, "kGrass", 269],
    [1, "kDinnertable", 408],
    [1, "kCandyCane", 498]
))
CloverDimension = table.const(table(
    [1, "kAnimal", 0],
    [1, "kBlue", 1],
    [1, "kGreen", 2],
    [1, "kOrange", 3],
    [1, "kPurple", 4],
    [1, "kRed", 5],
    [1, "kYellow", 6],
    [1, "kFourTile", 7],
    [1, "kLine", 8],
    [1, "kColumn", 9],
    [1, "kWrap", 10],
    [1, "kColor", 11],
    [1, "kSuperBird", 12],
    [1, "kBlock", 13],
    [1, "kNone", 14],
    [1, "kMoveTile", 15],
    [1, "kJellyfish0", 16],
    [1, "kJellyfish1", 17],
    [1, "kJellyfish2", 18],
    [1, "kJellyfish3", 19],
    [1, "kAlienA", 20],
    [1, "kAlienB", 21],
    [1, "kMissile", 22],
    [1, "kVariousBox1", 23],
    [1, "kVariousBox2", 23],
    [1, "kVariousBox3", 24],
    [1, "kStarfish1", 25],
    [1, "kStarfish2", 25],
    [1, "kStarfish3", 26],
    [1, "kLighthouse0", 27],
    [1, "kLighthouse1", 28],
    [1, "kLotus", 29],
    [1, "kSurfingCat1_1", 30],
    [1, "kSurfingCat1_2", 30],
    [1, "kSurfingCat1_3", 30],
    [1, "kSurfingCat2_1", 31],
    [1, "kSurfingCat2_2", 31],
    [1, "kSurfingCat2_3", 31],
    [1, "kScoreAnimal", 32],
    [1, GameItemType.kLock, 33],
    [1, GameItemType.kCoin, 34],
    [1, GameItemType.kCrystal, 35],
    [1, GameItemType.kSeaAnimal_1_1, 36],
    [1, GameItemType.kSeaAnimal_1_2, 37],
    [1, GameItemType.kSeaAnimal_2_1, 37],
    [1, GameItemType.kSeaAnimal_2_2, 38],
    [1, GameItemType.kSeaAnimal_2_3, 39],
    [1, GameItemType.kSeaAnimal_3_2, 39],
    [1, GameItemType.kHoneyBottle, 40],
    [1, GameItemType.kHoney, 41],
    [1, GameItemType.kDandelion, 42],
    [1, GameItemType.kBoat, 43],
    [1, GameItemType.kDigWater, 44],
    [1, GameItemType.kVenom, 45],
    [1, GameItemType.kPaw, 46],
    [1, GameItemType.kBlockMachine, 47],
    [1, GameItemType.kGum, 48],
    [1, GameItemType.kPursueStart, 49],
    [1, GameItemType.kPursueEnd, 50],
    [1, GameItemType.kSurpriseBox, 51],
    [1, GameItemType.kSurpriseBox + 1, 52],
    [1, "kReef", 53],
    [1, GameItemType.kSoil, 54],
    [1, GameItemType.kSoil + 1, 54],
    [1, GameItemType.kSoil + 2, 54],
    [1, GameItemType.kVar_Snow, 55],
    [1, GameItemType.kVar_Snow + 1, 56],
    [1, GameItemType.kVar_Snow + 2, 56],
    [1, GameItemType.kVar_Snow + 3, 56],
    [1, GameItemType.kVar_Snow + 4, 56],
    [1, GameItemType.kIce, 57],
    [1, GameItemType.kIce + 1, 58],
    [1, GameItemType.kIce + 2, 58],
    [1, "kFish", 59],
    [1, GameItemType.kFurball, 61],
    [1, GameItemType.kFurball + 1, 61],
    [1, GameItemType.kFurball + 2, 62],
    [1, GameItemType.kFurball + 3, 62],
    [1, GameItemType.kFurball + 4, 63],
    [1, GameItemType.kFurball + 5, 63],
    [1, GameItemType.kFurball + 6, 64],
    [1, GameItemType.kFurball + 7, 64],
    [1, GameItemType.kBigBox, 65],
    [1, GameItemType.kBigBox + 1, 66],
    [1, GameItemType.kBigBox + 2, 66],
    [1, GameItemType.kBigBox + 3, 66],
    [1, "kCake", 67],
    [1, GameItemType.kBowknot, 68],
    [1, GameItemType.kBowknot + 1, 69],
    [1, GameItemType.kBowknot + 2, 69],
    [1, GameItemType.kBowknot + 3, 69],
    [1, GameItemType.kBowknot + 4, 69],
    [1, GameItemType.kShell, 70],
    [1, GameItemType.kShell + 1, 71],
    [1, GameItemType.kShell + 2, 71],
    [1, "kSuperHoneyBottle_1", 72],
    [1, "kSuperHoneyBottle_2", 73],
    [1, GameItemType.kRatel, 74],
    [1, "kProducer", 75],
    [1, GameItemType.kSoda_1_2, 76],
    [1, GameItemType.kSoda_2_1, 76],
    [1, GameItemType.kSoda_1_2_symmetry, 77],
    [1, GameItemType.kSoda_2_1_symmetry, 77],
    [1, GameItemType.kIceBomb, 78],
    [1, "kPortalEnter", 79],
    [1, "kPortalExit", 80],
    [1, "kTransTypeLeft", 81],
    [1, "kTransTypeRight", 82],
    [1, "kTransTypeUp", 83],
    [1, "kTransTypeDown", 84],
    [1, "kTransLinkLU", 85],
    [1, "kTransLinkLD", 86],
    [1, "kTransLinkRU", 87],
    [1, "kTransLinkRD", 88],
    [1, "kCakeShooter_0", 89],
    [1, "kCakeShooter_1", 90],
    [1, "kCakeShooter_2", 91],
    [1, "kCakeShooter_3", 92],
    [1, "kCakeShooter_4", 93],
    [1, "kCakeShooter_5", 94],
    [1, "kCakeShooter_6", 95],
    [1, "kCakeShooter_7", 96],
    [1, "kShark_0", 97],
    [1, "kShark_1", 98],
    [1, "kShark_2", 99],
    [1, "kShark_3", 100],
    [1, "kShark_4", 101],
    [1, "kShark_5", 102],
    [1, "kShark_6", 103],
    [1, "kShark_7", 104],
    [1, "kGummyWorm", 105],
    [1, "kCandyFloss", 106],
    [1, "kFlowerVine_1", 107],
    [1, "kFlowerVine_2", 108],
    [1, "kFlowerVine_3", 108],
    [1, "kFlowerVine_4", 108],
    [1, GameItemType.kCapsuleToy, 109],
    [1, GameItemType.kCapsuleToy + 1, 110],
    [1, GameItemType.kCapsuleToy + 2, 111],
    [1, "kGrass", 112],
    [1, "kBlockNoDamage", 113],
    [1, GameItemType.kColorBlock_1, 114],
    [1, GameItemType.kColorBlock_2, 115],
    [1, GameItemType.kColorBlock_3, 116],
    [1, GameItemType.kColorBlock_4, 117],
    [1, GameItemType.kColorBlock_5, 118],
    [1, GameItemType.kColorBlock_6, 119],
    [1, "kVulnerable_1_1", 120],
    [1, "kVulnerable_1_2", 121],
    [1, "kVulnerable_1_3", 122],
    [1, "kVulnerable_1_4", 123],
    [1, "kVulnerable_2_1", 120],
    [1, "kVulnerable_2_2", 121],
    [1, "kVulnerable_2_3", 122],
    [1, "kVulnerable_2_4", 123],
    [1, "kVulnerable_3_1", 120],
    [1, "kVulnerable_3_2", 121],
    [1, "kVulnerable_3_3", 122],
    [1, "kVulnerable_3_4", 123],
    [1, "kNestDoll", 124],
    [1, "kBlastCrystal", 125],
    [1, "kRocket_1", 126],
    [1, "kRocket_2", 127],
    [1, "kRocket_3", 128],
    [1, "kRocket_4", 129],
    [1, "kTurnTileControl", 130],
    [1, "kColoredFrosting", 131],
    [1, "kCandyYoyo_head", 132],
    [1, "kCandyYoyo_tail", 133],
    [1, "kSeaAnemone_1", 134],
    [1, "kSeaAnemone_2", 135],
    [1, "kMint", 136],
    [1, "kJamjar_1", 137],
    [1, "kJamjar_2", 138],
    [1, "kJamjar_3", 139],
    [1, "kMushroom_1", 140],
    [1, "kMushroom_2", 141],
    [1, "kFishnet", 142],
    [1, LockItemType.kUFO, 143],
    [1, "kFlashBird", 144],
    [1, GameItemType.kColorCollector, 145],
    [1, "kPastry_Empty", 146],
    [1, "kPastry_Blue", 147],
    [1, "kPastry_Green", 148],
    [1, "kPastry_Brown", 149],
    [1, "kPastry_Purple", 150],
    [1, "kPastry_Red", 151],
    [1, "kPastry_Yellow", 152],
    [1, "kCheeseRat", 153],
    [1, "kCheeseRat_Box_1", 154],
    [1, "kCheeseRat_Box_2", 155],
    [1, "kCheeseRat_Box_3", 155],
    [1, "kCroissant_1", 156],
    [1, "kCroissant_2", 157],
    [1, "kCroissant_3", 158],
    [1, "kPopCan_1_1", 159],
    [1, "kPopCan_1_2", 160],
    [1, "kPopCan_1_3", 161],
    [1, "kPopCan_1_4", 162],
    [1, "kPopCan_2_1", 163],
    [1, "kPopCan_2_2", 164],
    [1, "kPopCan_2_3", 165],
    [1, "kPopCan_2_4", 166],
    [1, "kPopCan_3_1", 163],
    [1, "kPopCan_3_2", 164],
    [1, "kPopCan_3_3", 165],
    [1, "kPopCan_3_4", 166],
    [1, "kFilbert_1", 167],
    [1, "kFilbert_2", 168],
    [1, "kFilbert_3", 168],
    [1, "kFireWork", 169],
    [1, "kFireCracker_1", 170],
    [1, "kFireCracker_2", 171],
    [1, "kFireCracker_3", 171],
    [1, "kIcecreamCollector", 172],
    [1, "kIcecream", 173],
    [1, "kLamp", 174],
    [1, "kLampHead", 175],
    [1, "kLaser0", 176],
    [1, "kLaser1", 177],
    [1, "kLaser2", 178],
    [1, "kLaser3", 179],
    [1, "kEgg1", 180],
    [1, "kEgg2", 181],
    [1, "kEgg3", 181],
    [1, "kDye1", 182],
    [1, "kDye2", 183],
    [1, "kDye3", 184],
    [1, "kDye4", 185],
    [1, "kDye5", 186],
    [1, "kDye6", 187],
    [1, "kMagicbottle1", 188],
    [1, "kMagicbottle2", 189],
    [1, "kDinnertable", 190],
    [1, "kBombCandyA", 191],
    [1, "kBombCandy", 192],
    [1, "kTorpedo_0", 193],
    [1, "kTorpedo_1", 194],
    [1, "kTorpedo_2", 195],
    [1, "kTorpedo_3", 196],
    [1, "kTorpedo_4", 197],
    [1, "kTorpedo_5", 198],
    [1, "kTorpedo_6", 199],
    [1, "kTorpedo_7", 200],
    [1, "kBiscuit_1", 201],
    [1, "kBiscuit_2", 202],
    [1, "kBiscuit_3", 203],
    [1, "kBiscuit_4", 204],
    [1, "kPopcorn", 205],
    [1, "kNest", 206],
    [1, "kActGiftBox", 207],
    [1, "kHunter", 208],
    [1, GameItemType.kDiamond, 209],
    [1, GameItemType.kDiamond + 1, 210],
    [1, GameItemType.kDiamond + 2, 210],
    [1, "kCannedFishA", 211],
    [1, "kCannedFishB", 212],
    [1, "kMiniOctopus_1_0", 213],
    [1, "kMiniOctopus_1_1", 214],
    [1, "kMiniOctopus_1_2", 215],
    [1, "kMiniOctopus_1_3", 216],
    [1, "kMiniOctopus_2_0", 217],
    [1, "kMiniOctopus_2_1", 218],
    [1, "kMiniOctopus_2_2", 219],
    [1, "kMiniOctopus_2_3", 220],
    [1, "kMiniOctopus_3_0", 221],
    [1, "kMiniOctopus_3_1", 222],
    [1, "kMiniOctopus_3_2", 223],
    [1, "kMiniOctopus_3_3", 224],
    [1, "kMiniOctopus_4_0", 225],
    [1, "kMiniOctopus_4_1", 226],
    [1, "kMiniOctopus_4_2", 227],
    [1, "kMiniOctopus_4_3", 228],
    [1, "kJamBox", 229],
    [1, "kLaser", 230],
    [1, GameItemType.kJam, 231],
    [1, GameItemType.kJam + 1, 232],
    [1, "kFoamBomb", 233],
    [1, "kIcePopBox", 234],
    [1, "kSafe", 235],
    [1, "kCircusA", 236],
    [1, "kCircusB", 237],
    [1, "kCircus_Ball_1", 238],
    [1, "kCircus_Ball_2", 239],
    [1, GameItemType.kWoodBox, 240],
    [1, GameItemType.kWoodBox + 1, 241],
    [1, GameItemType.kWoodBox + 2, 241],
    [1, GameItemType.kWoodBox + 3, 241],
    [1, GameItemType.kWoodBox + 4, 241],
    [1, "kCandyCane", 242],
    [1, GameItemType.kMangosteen, 243],
    [1, GameItemType.kMangosteen + 1, 244],
    [1, GameItemType.kMangosteen + 2, 244],
    [1, GameItemType.kMangosteen + 3, 244],
    [1, GameItemType.kMangosteen + 4, 244],
    [1, "kSupportStick", 245],
    [1, "kIceBomb_ic", 246],
    [1, "kCakeShooter_ic", 247],
    [1, "kCoin_ic", 248],
    [1, "kRocket_ic", 249],
    [1, "kJellyfish_ic", 250],
    [1, "kFlashBird_ic", 251],
    [1, "kFireWork_ic", 252],
    [1, "kFireCracker_ic", 253],
    [1, "kPopcorn_ic", 254],
    [1, "kDiamond_ic", 255],
    [1, "kDiamondSolid_ic", 256],
    [1, "kShark_ic", 257],
    [1, "kFoamBomb_ic", 258],
    [1, "kVar_Snow_ic", 259],
    [1, "kVenom_ic", 260],
    [1, "kCandyFloss_ic", 261],
    [1, "kGummyWorm_ic", 262],
    [1, "kVulnerable_ic", 263],
    [1, "kNestDoll_ic", 264],
    [1, "kColoredFrosting_ic", 265],
    [1, "kCandyYoyo_ic", 266],
    [1, "kPastry_ic", 267],
    [1, "kCroissant_ic", 268],
    [1, "kFilbert_ic", 269],
    [1, "kBiscuit_ic", 270],
    [1, "kSafe_ic", 271],
    [1, "kWoodBox_ic", 272],
    [1, "kCannedFish_ic", 273],
    [1, "kIcePopBox_ic", 274],
    [1, "kGum_ic", 275],
    [1, "kSurpriseBox_ic", 276],
    [1, "kDandelion_ic", 277],
    [1, "kJam_ic", 278],
    [1, "kMangosteen_ic", 279],
    [1, "kBoat_ic", 280],
    [1, "kSurpriseBonus_ic", 281],
    [1, "kJamJar_ic", 282],
    [1, "kPopCan_ic", 283],
    [1, "kCheeseRat_ic", 284],
    [1, "kEgg_ic", 285],
    [1, "kAlienB_ic", 286],
    [1, "kIcecreamCollector_ic", 287],
    [1, "kHoney_ic", 288],
    [1, "kPaw_ic", 289]
))
GameColor = table.const(table(
    [1, "kNone", 30],
    [1, "kRandom", 0],
    [1, "kBlue", 1],
    [1, "kGreen", 2],
    [1, "kBrown", 3],
    [1, "kPurple", 4],
    [1, "kRed", 5],
    [1, "kYellow", 6]
))
AnimalTypeConfig = table.const(table(
    [1, "kNone", 30],
    [1, "kRandom", 0],
    [1, "kBlue", 1],
    [1, "kGreen", 2],
    [1, "kOrange", 3],
    [1, "kPurple", 4],
    [1, "kRed", 5],
    [1, "kYellow", 6],
    [1, "kFourTile", 7],
    [1, "kLine", 8],
    [1, "kColumn", 9],
    [1, "kWrap", 10],
    [1, "kColor", 11],
    [1, "kSuperBird", 12],
    [1, "kNuclear", 13],
    [1, "kLineOrColumn", 15],
    [1, "kAlienA", 20],
    [1, "kAlienB", 21],
    [1, "kCircle", 22],
    [1, "kMissile", 23],
    [1, "kGuideSpecial", 999]
))
GuideSpecialTypeList = table(
    [0, AnimalTypeConfig.kFourTile],
    [0, AnimalTypeConfig.kLine],
    [0, AnimalTypeConfig.kColumn],
    [0, AnimalTypeConfig.kWrap],
    [0, AnimalTypeConfig.kColor],
    [0, AnimalTypeConfig.kSuperBird]
)
GamePlayType = table.const(table(
    [1, "kNone", 0],
    [1, "kOrder", 1],
    [1, "kIce", 2],
    [1, "kFish", 3],
    [1, "kProtectFish", 4],
    [1, "kBlockCollection", 5],
    [1, "kBlockLight", 6],
    [1, "kBoss", 7],
    [1, "kDropDig", 8],
    [1, "kWaterDig", 9],
    [1, "kWeekly", 10],
    [1, "kPursue", 11],
    [1, "kMagic", 12],
    [1, "kGold", 13],
    [1, "kUnionWar", 14],
    [1, "kPvp", 30],
    [1, "kOneStep", 31],
    [1, "kTimeBlockCollection", 32],
    [1, "kBaiduXiaoshu", 33]
))
LevelConstans = table.const(table(
    [1, "MAIN_LEVEL_ID_START", 0],
    [1, "MAIN_LEVEL_ID_END", 9998],
    [1, "Editor_LEVEL_ID", 9999],
    [1, "HIDE_LEVEL_ID_START", 10000],
    [1, "HIDE_LEVEL_ID_END", 19999],
    [1, "DIGGER_MATCH_LEVEL_ID_START", 20000],
    [1, "DIGGER_MATCH_LEVEL_ID_END", 29999],
    [1, "MAYDAY_ENDLESS_LEVEL_ID_START", 150000],
    [1, "MAYDAY_ENDLESS_LEVEL_ID_END", 151000],
    [1, "RECALL_TASK_LEVEL_ID_START", 170000],
    [1, "RECALL_TASK_LEVEL_ID_END", 179999],
    [1, "TASK_FOR_UNLOCK_AREA_START", 200000],
    [1, "TASK_FOR_UNLOCK_AREA_END", 209999],
    [1, "SUMMER_MATCH_LEVEL_ID_START", 230000],
    [1, "SUMMER_MATCH_LEVEL_ID_END", 239999],
    [1, "QIXI2015_LEVEL_ID_START", 250000],
    [1, "QIXI2015_LEVEL_ID_END", 259999],
    // [1, "ABTEST_LEVEL_ID_START", 60001],
    // [1, "ABTEST_LEVEL_ID_END", 70000],
    [1, "WEEKLY_LEVEL_ID_START", 70001],
    [1, "WEEKLY_LEVEL_ID_END", 80000],
    [1, "WEEKLY_LEVEL_ID_EASY_S", 70000],
    [1, "WEEKLY_LEVEL_ID_MID_S", 71000],
    [1, "WEEKLY_LEVEL_ID_HARD_S", 72000],
    // [1, "MAGIC_LEVEL_ID_START", 73000],
    // [1, "MAGIC_LEVEL_ID_MID_S", 74000],
    // [1, "MAGIC_LEVEL_ID_HARD_S", 75000],
    // [1, "MAGIC_LEVEL_ID_END", 76000],
    [1, "ACTIVITY_MISSION_LEVEL_ID_S", 80001],
    [1, "ACTIVITY_MISSION_LEVEL_ID_E", 80020],
    // [1, "ACTIVITY_NEW_YEAR_2018_ID_S", 85001],
    // [1, "ACTIVITY_NEW_YEAR_2018_ID_E", 85015],
    // [1, "ACTIVITY_SPRING_2018_ID_S", 83001],
    // [1, "ACTIVITY_SPRING_2018_ID_E", 83046],
    // [1, "ACTIVITY_STORY_ID_S", 88051],
    // [1, "ACTIVITY_STORY_ID_E", 88084],
    // [1, "ACTIVITY_LABOR_ID_S", 83051],
    // [1, "ACTIVITY_LABOR_ID_E", 83080],
    // [1, "ACTIVITY_DRAGON_BOAT_ID_S", 83081],
    // [1, "ACTIVITY_DRAGON_BOAT_ID_E", 83095],
    // [1, "ACTIVITY_JULY_AC_ID_S", 83101],
    // [1, "ACTIVITY_JULY_AC_ID_E", 83115],
    // [1, "ACTIVITY_AUGUST_RETAIN_ID_S", 85501],
    // [1, "ACTIVITY_AUGUST_RETAIN_ID_E", 85515],
    [1, "ACTIVITY_GOLD_ID_S", 89001],
    [1, "ACTIVITY_GOLD_ID_E", 89091],
    // [1, "ACTIVITY_NATION2018_ID_S", 83116],
    // [1, "ACTIVITY_NATION2018_ID_E", 83130],
    // [1, "MAGIC_ENDLESS_ID", 76000],
    // [1, "ACTIVITY_MAKE_TEA_ID_S", 86001],
    // [1, "ACTIVITY_MAKE_TEA_ID_E", 86500],
    // [1, "ACTIVITY_UNION_WAR_S", 86501],
    // [1, "ACTIVITY_UNION_WAR_E", 86600]
    [1, "PVP_LEVEL_ID_S", 90000],
    [1, "PVP_LEVEL_ID_E", 91000],
    [1, "FRIEND_PVP_LEVEL_ID_S", 90100],
    [1, "FRIEND_PVP_LEVEL_ID_E", 91000],
    [1, "ACT_DEC_2018_ID_S", 83146],
    [1, "ACT_DEC_2018_ID_E", 83160],
    [1, "ONE_STEP_LEVEL_ID_S", 100000],
    [1, "ONE_STEP_LEVEL_ID_E", 101000],
    [1, "TIME_BLOCK_LEVEL_ID_S", 102000],
    [1, "TIME_BLOCK_LEVEL_ID_E", 103000],
    [1, "COIN_MATCH_LEVEL_ID_S", 104000],
    [1, "COIN_MATCH_LEVEL_ID_E", 105000],
    [1, "BUILD_SHIP_LEVEL_ID_S", 110001],
    [1, "BUILD_SHIP_LEVEL_ID_E", 119999],
    [1, "MYSTERY_ISLAND_LEVEL_ID_START", 30000],
    [1, "MYSTERY_ISLAND_LEVEL_ID_END", 39999],
    [1, "MYSTERY_ISLAND_Editor_LEVEL_ID", 39999],
))
GameLevelType = table(
    [1, "kQixi", 1],
    [1, "kMainLevel", 2],
    [1, "kHiddenLevel", 3],
    [1, "kWeekly", 4],
    [1, "kMayDay", 5],
    [1, "kTaskForRecall", 8],
    [1, "kTaskForUnlockArea", 9],
    [1, "kSummerWeekly", 10],
    [1, "kEditor", 11],
    // [1, "kABTest", 12],
    // [1, "kActivityMissionLevel", 13],
    // [1, "kNewYear2018", 14],
    [1, "kMagic", 15],
    // [1, "kSpring2018", 16],
    // [1, "kStoryActivity", 17],
    // [1, "kLabor", 18],
    [1, "kGold", 19],
    // [1, "kJulyAc", 20],
    // [1, "kAugustRetain", 21],
    // [1, "kNationDay2018", 22],
    // [1, "kMakeTea", 23],
    // [1, "kUnionWar", 24]
    // [1, "kIslandLevel", 25],
    // [1, "kActDec2018", 26],
    // [1, "kSpring2019", 27]
    [1, "kPvp", 30],
    [1, "kOneStep", 31],
    [1, "kTimeBlockCollection", 32],
    [1, "kCoinMatch", 33],
    [1, "kBaiduXiaoshu", 34],
    //[1, "kPuzzlePassAct", "kPuzzlePassAct"]
    [1, "kMysteryIsland", 35],
    [1, "kBuildShip", 36],

)
GamePlayStatus = table(
    [1, "kPreStart", 0],
    [1, "kNormal", 1],
    [1, "kEnd", 2],
    [1, "kBonus", 3],
    [1, "kAferBonus", 4],
    [1, "kWin", 5],
    [1, "kFailed", 6]
)
GameItemStatusType = table(
    [1, "kNone", 0],
    [1, "kIsMatch", 1],
    [1, "kIsSpecialCover", 2],
    [1, "kIsFalling", 4],
    [1, "kJustStop", 5],
    [1, "kItemHalfStable", 6],
    [1, "kWaitBomb", 7],
    [1, "kDestroy", 8],
    [1, "kDelayBomb", 9],
    [1, "kResistSpecial", 10]
)
GameItemDirection = table(
    [1, "kNone", 0],
    [1, "kUp", 1],
    [1, "kRight", 2],
    [1, "kDown", 3],
    [1, "kLeft", 4]
)
WaterBombDirection = table.const(table(
    [1, "kUp", 0],
    [1, "kRightUp", 1],
    [1, "kRight", 2],
    [1, "kRightDown", 3],
    [1, "kDown", 4],
    [1, "kLeftDown", 5],
    [1, "kLeft", 6],
    [1, "kLeftUp", 7]
))
EightDirection = table.const(table(
    [1, "kUp", 0],
    [1, "kRightUp", 1],
    [1, "kRight", 2],
    [1, "kRightDown", 3],
    [1, "kDown", 4],
    [1, "kLeftDown", 5],
    [1, "kLeft", 6],
    [1, "kLeftUp", 7]
))
FourDirection = table.const(table(
    [1, "kUp", 0],
    [1, "kRight", 1],
    [1, "kDown", 2],
    [1, "kLeft", 3]
))
GameItemDirectionTurn = table.const(table(
    [1, "kNone", 0],
    [1, "kLeftToRight", 1],
    [1, "kRightToLeft", 2]
))
RoadType = table.const(table(
    [1, "kNone", 0],
    [1, "kFish", 1],
    [1, "kPursue", 2]
))
RoadCornerType = table.const(table(
    [1, "kNone", 0],
    [1, "kHorizontal", 1],
    [1, "kVertical", 2],
    [1, "kCorner_RU", 3],
    [1, "kCorner_LU", 4],
    [1, "kCorner_RD", 5],
    [1, "kCorner_LD", 6],
    [1, "kCorner_Start", 7],
    [1, "kCorner_End", 8],
    [1, "kStart_R", 9],
    [1, "kStart_L", 10],
    [1, "kStart_U", 11],
    [1, "kStart_D", 12],
    [1, "kEnd_R", 13],
    [1, "kEnd_L", 14],
    [1, "kEnd_U", 15],
    [1, "kEnd_D", 16]
))
AnimalMergeType = table.const(table(
    [1, "kCommon", 0],
    [1, "kAlienA", 1],
    [1, "kAlienB", 2],
    [1, "kCircle", 3],
    [1, "kSeperate", 100]
))
GameItemDelayBombType = table.const(table(
    [1, "kComplete", -1],
    [1, "kNone", 0],
    [1, "kCommon", 1],
    [1, "kLine", 2],
    [1, "kColumn", 3],
    [1, "kWrap", 4],
    [1, "kFourTile", 5],
    [1, "kMaxState", 10]
))
GameItemFurballType = table.const(table(
    [1, "kNone", 0],
    [1, "kMoveH", 1],
    [1, "kMoveV", 2],
    [1, "kMoveHV", 3],
    [1, "kFree", 4]
))
GameItemColorToBossEffect = table.const(table(
    [1, "kNormal", 0],
    [1, "kEffect", 1],
    [1, "kUnEffect", 2]
))
GameDropRuleType = table.const(table(
    [1, "kStep", 1],
    [1, "kProb", 2],
    [1, "kCycle", 3]
))
GameDropModeType = table.const(table(
    [1, "kStep", 1],
    [1, "kOrder", 2],
    [1, "kStage", 3]
))
GameItemBossHitType = table.const(table(
    [1, "kNormal", 0],
    [1, "kLittle", 1],
    [1, "kHeavy", 2]
))
GameOrderDataStatus = table.const(table(
    [1, "kWaiting", 0],
    [1, "kActived", 1],
    [1, "kFinished", 2]
))
FishSwimState = table.const(table(
    [1, "kNone", 0],
    [1, "kStart", 1],
    [1, "kSwim", 2],
    [1, "kEnd", 3]
))
FishMoveType = table.const(table(
    [1, "kStart", 1],
    [1, "kMove", 2],
    [1, "kEnd", 3],
    [1, "kWait", 4],
    [1, "kShow", 6],
    [1, "kRecycleEnd", 7],
    [1, "kRecycle", 8]
))
HideLevelState = table.const(table(
    [1, "kNone", 0],
    [1, "kActive", 1],
    [1, "kPass", 2]
))
TurnTileConst = table.const(table(
    [1, "kA", "A"],
    [1, "kB", "B"],
    [1, "kAF", "AF"],
    [1, "kAB", "AB"],
    [1, "kBF", "BF"],
    [1, "kBB", "BB"],
    [1, "kHL", "hor_left"],
    [1, "kHR", "hor_right"],
    [1, "kVT", "ver_top"],
    [1, "kVD", "ver_down"]
))
ModuleName = table.const(table(
    [1, "SHOP", "shop"],
    [1, "SHAKE", "shake"],
    [1, "SHAKE_OCTOPUS", "shake_octopus"],
    [1, "ENERGY", "energy"],
    [1, "STAR_BOOK", "star_book"],
    [1, "HAPPY_COIN", "happy_coin"],
    [1, "FRIENDS", "friends"],
    [1, "INFO", "info"],
    [1, "BAG", "bag"],
    [1, "MESSAGE", "message"],
    [1, "FC", "fc"],
    [1, "STAGE_GAME", "stage_game"],
    [1, "STAGE_START", "stage_start"],
    [1, "STAGE_REWARD", "stage_reward"],
    [1, "STAGE_REWARD_BONUS", "stage_reward_bonus"],
    [1, "STAGE_END", "stage_end"],
    [1, "ADD_FIVE", "add_five"],
    [1, "GET_ENERGY", "get_energy"],
    [1, "SHAKE_REWARD", "shake_reward"],
    [1, "SHAKE_TOTAL", "shake_total"],
    [1, "LEVEL_REWARD", "level_reward"],
    [1, "NEW_USER", "new_user"],
    [1, "NEW_TASK", "new_task"],
    [1, "MARK", "mark"],
    [1, "STAR_COLLECTION", "star_collection"],
    [1, "STAR_TOTAL", "star_total"],
    [1, "BUY_GAME_COINS", "buy_game_coins"],
    [1, "BUY_HAPPY_COINS", "buy_happy_coins"],
    [1, "BUY_RMB_COINS", "buy_rmb_coins"],
    [1, "FRIENDS_FREE_GIFT", "free_gift"],
    [1, "FRIENDS_INVITE", "friends_invite"],
    [1, "FRIENDS_INVITE_COUNT", "friends_invite_count"],
    [1, "GUIDE", "guide"],
    [1, "MAIL", "mail"],
    [1, "UNLOCK", "unlock"],
    [1, "BETA_GIFT", "beta_gift"],
    [1, "ACTIVITY_SHARE", "activity_share"],
    [1, "MARK_LIMIT_GIFT", "mark_limit_gift"],
    [1, "COUPON", "coupon"],
    // [1, "HIDELEVELREPLAY", "hidelevel_replay"],
    [1, "HONOR_RANK", "honor_rank"],
    // [1, "PROMOTION", "promotion"],
    // [1, "REAL_NAME", "real_name"],
    [1, "WEEK_GAME", "week_game"],
    [1, "ACTIVITY_MISSION", "activity_mission"],
    // [1, "ACTIVITY_SPRING_DOG", "activity_spring_dog"],
    // [1, "DYNAMIC_GIFT_ENERGY", "dynamic_gift_energy"],
    // [1, "COIN_DOZER", "coin_dozer"],
    // [1, "FUNS_CARE", "funs_care"],
    // [1, "GAME_SETTING", "game_setting"],
    // [1, "QQ_BBS", "qq_bbs"],
    // [1, "CAPTAIN_TASK", "captain_task"],
    // [1, "VIDEO_AD", "video_ad"],
    // [1, "REVIVE_TURN_TABLE", "revive_turn_table"],
    // [1, "ONE_PIECE", "one_piece"],
    // [1, "TOP_LEVEL_TASK", "topLevelTask"],
    // [1, "RECALL_REWARD", "recall_reward"],
    // [1, "PIGGY_BANK", "piggy_bank"],
    // [1, "AUGUST", "august"],
    // [1, "GIFT_PACK_OF_LEVEL_AREA", "gfola"],
    // [1, "SOCIAL", "social"],
    // [1, "NAME_CARD", "name_card"],
    // [1, "SNS_LINK", "sns_link"]
    [1, "GIFT", "gift"],
    [1, "SHORTCUT_REWARD", "shortcut_reward"],
    [1, "QZONEBACKGOUND_REWARD", "shortcut_reward"],
    [1, "FORUM", "forum"],
    [1, "FAQ", "FAQ"],
    [1, "WEEKEND_LOGIN_ACTIVITY", "weekend_login_activity"],
    [1, "SPRING_LOGIN_ACTIVITY", "spring_login_activity"],
    [1, "SEVEN_DAY_LOGIN", "seven_day_login"],
    [1, "WANTED_AVTIVITY", "wanted_avtivity"],
    [1, "DISCOUNT_SHOP", "discount_shop"],
    [1, "SHARE_INVITE", "share_invite"],
    [1, "NEW_YEAR_ACTIVITY", "new_year_activity"],
    [1, "WANBA_VIP_PRIVILEGES", "wanba_vip_privileges"],
    [1, "PVP_ACTIVITY", "pvp_activity"],
    [1, "WX_SHARE", "wx_share"],
    [1, "NEW_USER_WX_SHARE", "new_user_wx_share"],
    [1, "CHEST_ACTIVITY", "chest_activity"],
    [1, "MARK_WX_SHARE", "mark_wx_share"],
    [1, "START_CHEST", "start_chest"],
    [1, "ISLAND_SYSTEM", "island_system"],
    [1, "ONE_STEP_ACTIVITY", "one_step_activity"],
    [1, "TIME_MODE_ACTIVITY", "time_mode_activity"],
    [1, "COIN_MATCH_ACTIVITY", "coin_match_activity"],
    [1, "WX_AD_VIDEO_WATCH", "wx_ad_video_watch"],
    [1, "SHOW_ME_THE_MONEY", "show_me_the_money"],
    [1, "GOLD_MATCH_ACTIVITY", "gold_match_activity"],
    [1, "RESCUR_MISSION", "rescur_mission_activity"],
    [1, "ActivityGacha", "gacha"],
    [1, "WX_HAPPYCOINSHORT_SHARE", "wx_happycoinshort_share"],
    [1, "FAIL_BUY_TWO", "fail_buy_two"],
    [1, "WX_COINSHORT_SHARE", "wx_coinshort_share"],                //  银币不足
    [1, "COLLECT_GIFT", "collect_gift"],
    [1, "BEFORE_STAGE", "before_stage"],                            //  进入关卡之前，目前用于识别关前道具购买
    [1, "INTO_STAGE", "into_stage"],                                //  进入关卡之后，目前用于识别进入关卡后提示道具购买
    [1, "ISLAND_REVIVE", "island_revive"],
    [1, "BUY_MOVES", "buy_moves"],                                  //  关末失败加步数
    [1, "PAY_PACK", "pay_pack"],                                    //  礼包功能
    [1, "SHOP_NEW", "new_store"],
    [1, "VERIFIED_SCHEDULE", "verified_schedule"],
    [1, "PVP_TICKET", "pvp_ticket"],                                //  pvp买门票
    [1, "FRIEND_PVP", "pvp"],                                       //  友谊赛获得
    [1, "INTERACTIVE_INVITE", "interactive"],                              //  互动邀请
    [1, "INTERACTIVE_PROGRESS", "interactive_progress"],                // 互赠礼物进度奖励
    [1, "VERIFIED_LOGIN", "verified_login"],
    [1, "VERIFIED_REDO", "verified_redo"],
    [1, "NEW_CHEST_SMALL", "new_chest_small"],                // 星星抽奖
    [1, "NEW_CHEST_BIG", "new_chest_big"],                // 星星抽奖
    [1, "NEWRAK_NEWFRIEND", "rank_newfriend_reward"],    // 新排行双向好友
    [1, "NEWRAK_PROGRESS", "rank_process_reward"],    // 新排行累记好友
    [1, "NEWRAK_ON", "rank_firsttime_reward"],    // 首次上榜
    [1, "NEWRAK_UP", "rank_congra_reward"],    // 排名上升
    [1, "INVITEPACK", "invitepack"],                                //  关末分享包
    [1, "TT_VIDEO_SHARE", "video_share"],                // 抖音录屏分享
    [1, "ISLAND_UNLOCK", "island_unlock"],                // 区域解锁
    [1, "ISLAND_FULLSTAR", "islands_fullstars"],                // 岛屿满星
    [1, "AI_PACKAGE", "ai_package"],  // AI礼包
    [1, "AD_PROP", "ad_prop"],  // 道具广告
    [1, "AD_GACHA", "ad_gacha"],  // 道具广告
    [1, "GACHA_ACCUMULATE", "gacha_accumulate"],  // 道具广告
    [1, "CALL_BACK_REWARD", "call_back_reward"],  // 道具广告
    [1, "PIGGY_BANK", "piggy_bank"],  // 存钱罐

    [1, "ISLAND_UPGRADE", "island_upgrade"],  // 道具广告
    [1, "COAST_STAR", "coast_star"],  // 海滨之星
    [1, "CHAMPION_RACE", "champion_race"],  // 海滨之星
    [1, "ADD_STAR", "addstar"],  // 补星
    [1, "AD_TASK", "ad_task"],  // 广告任务
    [1, "BATTLE_PASS", "battle_pass"],  // 通行证
    [1, "LIGHTNING_RUSH", "lightening_rush"],  // 限时闯关（萌萌闯关）
    [1, "NEW_USER_TASK", "new_user_task"],  // 新手任务（冒险任务）
    [1, "FESTIVAL_8TH_SHOP", "festival_shop"],  // 周年庆
    [1, "FESTIVAL_8TH_PASS", "festival_battle_pass"],  // 周年庆
    [1, "SECRET_SHOP", "secret_shop"],  // 神秘商店
    [1, "MYSTERY_ISLADN", "mystery_island"],  // 神秘岛
    [1, "PURPLE_MAGIC", "purple_magic"],  // 紫咪
    [1, "MAIN_RACE", "main_race"],  // 晋级赛
    [1, "WX_GIFT", "wechat_gift"],  // 晋级赛
    [1, "CD_KEY", "redeem_code"],  // 兑换码
    [1, "NOVICE_GIFT", "new_user_reward"],  // 新手礼包
    [1, "ENDLESS_TREASURE", "endless_treasure"],  // 无尽宝藏
    [1, "LEVEL_COLLECT", "collection_activity"],  // 主线收集
    [1, "SPEEDBOAT_MATCH", "speedboat_race"],  // 快艇大赛
    [1, "MONTH_TICK", "monthly_ticket"],  // 月票
    [1, "WELFARE_CENTER", "welfare_center"],  // 福利中心
    [1, "ISLAND_TREASURE", "island_treasure"],  // 通行证
    [1, "TT_PUSH_CARD", "douyin_refer"],  // 抖音推荐卡
    [1, "STICKER_BATTLE", "sticker_race"],  // 贴贴
    [1, "PICK_COCO", "island_coconut"],  // 摘椰子
    [1, "FISHING", "fishing_master"],  // 钓鱼大赛
    [1, "GOLD_ELYSIUM", "gold_elysium"],  // 金币乐园
    [1, "LiveGift", "limit_package"],  // 限定礼包
    [1, "AdSkipGiftBag", "ad_free_ticket"],  // 免广告礼包
    [1, "PERSONAL_SETTING", "personal_setting"],  // 个人信息
    [1, "SECRET_CODE", "MagicCode"],  // 解码特工队
    [1, "CIRCUSGAME", "CircusGame_reward"],  // 马戏团
    [1, "EXCAVATE_FOOD", "coffee_lot_cooking"],  // 挖宝石
    [1, "WATER_FIGHTING", "water_pvp"],  // 水枪
    [1, "NUCLEAR_BIRD", "super_bird"],  // 超鸟
    [1, "TRINITY_GIFT_BAG", "pick_package"],  // 三选一礼包
    [1, "SALVAGE_GIFT", "SalvageGiftBag"],  // 新救援礼包（关末加五步）
    [1, "PET_STORY", "pet_story"],  // 超鸟

))
ItemWorth = table.const(table(
    [1, "GAME_COINS", "game coins"],
    [1, "RMB", "rmb"],
    [1, "HAPPY_COINS", "happy coins"],
    [1, "CASH", "cash"],    // 星星抽奖现金
    [1, "OTHER", "other"]
))
WeekGameRankType = table(
    [1, "kFriends", 1],
    [1, "kArea", 2],
    [1, "kAll", 3]
)
PassLevelRewardType = table(
    [1, "kTarget", 1],
    [1, "kTempProp", 2],
    [1, "kAddTargetBuff", 3]
)
LevelDegreeType = table(
    [1, "kEasy", 0],
    [1, "kMid", 1],
    [1, "kHard", 2]
)
// TOP_USER_WG_STATE = table(
//     [1, "NONE", 0],
//     [1, "FREE2", 2],
//     [1, "FREE1GIFT1", 1]
// )
ACTION_TAG_CONST = table([1, "kRocketSwap", 10000])
// IslandPrivilege = table(
//     [1, "kNone", 0],
//     [1, "kNormal", 1],
//     [1, "kHead", 2]
// )
// IslandPrivilegeStatus = table(
//     [1, "kNone", 0],
//     [1, "kLock", 1],
//     [1, "kWaitingUnlock", 2]
// )
SpecialBombType = table(
    [1, "kBirdColor", 0],
    [1, "kBirdSpecial", 1],
    [1, "useItem", 2],
    [1, "popcorn", 3],
    [1, "hunter", 4],
    [1, "shark", 5],
    [1, "verticalLine", 6]
)